export default __webpack_public_path__ + "static/media/pineapple.6fa64295.png";